module.exports = __webpack_public_path__ + "static/media/speed-up.b7244a6f.png";